import { Controller } from "@hotwired/stimulus"

// Swap pastille ↔ encart du bloc d'aide (dashboard).
// Ouverture : swap instantané (d-none) + animation d'entrée en CSS ; le focus va sur le bouton de fermeture.
// Fermeture : on joue l'animation de sortie, on masque à la fin (animationend), puis le focus revient sur la pastille.
export default class extends Controller {
  static targets = ["pill", "panel", "inner", "pillButton", "closeButton"]

  open() {
    this.pillTarget.classList.add("d-none")
    this.panelTarget.classList.remove("d-none")
    this.closeButtonTarget.focus()
  }

  close() {
    this.innerTarget.classList.add("is-closing")
  }

  onAnimationEnd() {
    if (!this.innerTarget.classList.contains("is-closing")) return

    this.panelTarget.classList.add("d-none")
    this.pillTarget.classList.remove("d-none")
    this.innerTarget.classList.remove("is-closing")
    this.pillButtonTarget.focus()
  }
}
